import type { DeckEmbed } from '@/entities/embed'
import type { EditDeck } from './useEditDeck'

type DeckEmbedSearch = {
  readonly count: number
  readonly next: string | null
  readonly previous: string | null
  readonly results: DeckEmbed[]
}

export interface UseEmbedNavigation {
  goToEmbeds(): Promise<void>
}

export function useEmbedNavigation({ deck: { company_id, title, id } }: { deck: EditDeck }): UseEmbedNavigation {
  const { vpeUrl } = useVpeUrl()

  async function goToEmbeds() {
    const { count, results } = await $fetch<DeckEmbedSearch>(
      `v2/companies/${company_id}/embed/decks?deck_id=${id}`,
      useFetchSharedOptions()
    )

    if (count === 0) {
      _goToCreatePage(id)
    } else if (count === 1) {
      _goToEditPage(results[0])
    } else {
      _goToSearchPage(title)
    }
  }

  function _goToCreatePage(deckId: number) {
    window.open(`${vpeUrl}/embed/animated/editor?deckId=${deckId}`, '_blank')
  }

  function _goToEditPage({ type, id }: DeckEmbed) {
    const embedType = type === 'Deck Embed - Classic' ? 'classic' : 'animated'
    window.open(`${vpeUrl}/embed/${embedType}/editor/${id}`, '_blank')
  }

  function _goToSearchPage(searchTerm: string) {
    const url = new URL('embeds', vpeUrl)
    url.searchParams.set('search', searchTerm)

    window.open(url, '_blank')
  }

  return { goToEmbeds }
}
